/**
 * WebSocket URL — production uses same host (/ws via nginx).
 * Local dev: frontend :9001 → backend :8000
 */
export function getWebSocketUrl() {
  const { protocol, hostname, port, host } = window.location;
  const wsProto = protocol === 'https:' ? 'wss:' : 'ws:';

  const isLocalDev = hostname === 'localhost' || hostname === '127.0.0.1';
  if (isLocalDev) {
    const backendPort = process.env.REACT_APP_WS_PORT || process.env.REACT_APP_BACKEND_PORT || '8000';
    return `${wsProto}//${hostname}:${backendPort}/ws`;
  }

  // Production (kopartner.in): nginx proxies /ws — no :9001
  if (!port || port === '443' || port === '80') {
    return `${wsProto}//${host}/ws`;
  }

  const backendPort = process.env.REACT_APP_WS_PORT || '8000';
  return `${wsProto}//${hostname}:${backendPort}/ws`;
}
